import { action } from "mobx";
import { UkaiDatabaseRef } from "../config/firebase";

class SyncProgramStore {
  CurrentVersion = 4

  constructor(rootStore) {
    this.rootStore = rootStore;
  }
  updateTimestamp(time) {
    this.rootStore.lastSyncedProgramAt = time;
  }
  updateSyncProgram(programs) {
    this.rootStore.syncPrograms = { ...this.rootStore.syncPrograms || {}, ...programs };
  }

  removeSyncPrograms(programs) {
    const next = { ...this.rootStore.syncPrograms };
    Object.keys(programs).forEach((pid) => {
      delete next[pid];
    });
    this.rootStore.syncPrograms = next;
  }

  @action loadProgram(pid) {
    return UkaiDatabaseRef.child("programs")
      .child(pid)
      .once("value")
      .then((snapshot) => {
        if (snapshot.exists()) {
          const program = snapshot.val() || {};
          this.updateSyncProgram({ [pid]: program });
          return Promise.resolve(program);
        }
        return Promise.resolve({});
      });
  }

  @action loadPrograms() {
    if (this.rootStore.syncVersion !== this.CurrentVersion) {
      this.rootStore.syncVersion = this.CurrentVersion;
      this.rootStore.syncPrograms = {};
      this.rootStore.lastSyncedProgramAt = 0;
    }

    const lastSynced = this.rootStore.lastSyncedProgramAt;
    const programsRef = UkaiDatabaseRef.child("programs");

    const activeQuery = programsRef
      .orderByChild("idx_active_updated")
      .startAt(`true_${lastSynced}`)
      .endAt(`true_\uf8ff`)
      .once("value");

    // Inactive programs are only used to evict cached entries. On a full sync the cache
    // is empty, so skip downloading every inactive program (the bulk of the node).
    const inactiveQuery = lastSynced > 0
      ? programsRef
        .orderByChild("idx_active_updated")
        .startAt(`false_${lastSynced}`)
        .endAt(`false_\uf8ff`)
        .once("value")
      : Promise.resolve(null);

    return Promise.all([activeQuery, inactiveQuery]).then(([activeSnapshot, inactiveSnapshot]) => {
      let latestUpdatedAt = lastSynced;

      if (activeSnapshot.exists()) {
        const programs = activeSnapshot.val() || {};
        const addedOrUpdatedIds = Object.keys(programs);
        this.updateSyncProgram(programs);
        Object.values(programs).forEach((program) => {
          if (program.updatedAt > latestUpdatedAt) {
            latestUpdatedAt = program.updatedAt;
          }
        });
      }

      if (inactiveSnapshot && inactiveSnapshot.exists()) {
        const programs = inactiveSnapshot.val() || {};
        const removedIds = Object.keys(programs);
        this.removeSyncPrograms(programs);
        Object.values(programs).forEach((program) => {
          if (program.updatedAt > latestUpdatedAt) {
            latestUpdatedAt = program.updatedAt;
          }
        });
      }

      if (latestUpdatedAt > lastSynced) {
        this.updateTimestamp(latestUpdatedAt);
      }

      return Promise.resolve(this.rootStore.syncPrograms);
    });
  }
}

export default SyncProgramStore;